import React from 'react'
import { PixelAlert, PixelCurrency, colors } from 'pixel-base'
import styled from 'styled-components'
const tenant_info: any = JSON.parse(localStorage.getItem('tenant_info') || '{}')
const AlertCard = (props) => {
  const {
    mainDec,
    variant,
    title,
    totalCount,
    isCOD,
    COD,
    CODDec,
    countINCurrency,
    extraLines,
    isCourier,
    style,
    logo = '',
    showTitle = true,
  } = props
  return (
    <StatsCard style={style} variant={variant}>
      {showTitle && (
        <StatsItemTitle>
          {logo !== '' && <CourierLogo src={logo} />}&nbsp;{title}
        </StatsItemTitle>
      )}

      <StatsItems className={isCourier ? 'isCourier' : ''}>
        {countINCurrency ? (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                fontSize: '10px',
                marginTop: '2px',
              }}
            >
              {tenant_info?.default_currency_symbol}
            </span>{' '}
            <PixelCurrency hideSymbol value={totalCount} />
          </span>
        ) : (
          <>{totalCount || 0}</>
        )}
        <StatsItemCount>{mainDec}</StatsItemCount>
      </StatsItems>
      {isCOD && (
        <StatsItems>
          <span
            style={{
              fontSize: '13px',
            }}
          >
            <span
              style={{
                fontSize: '10px',
              }}
            >
              {tenant_info?.default_currency_symbol}
            </span>
            <PixelCurrency hideSymbol={true} value={COD} />
          </span>

          <StatsItemCount
            style={{
              marginBottom: '2px',
              fontSize: '10px',
            }}
          >
            {CODDec || 0}
          </StatsItemCount>
        </StatsItems>
      )}
      {extraLines &&
        extraLines.map((item, index) => (
          <StatsItems key={index}>
            <span
              style={{
                fontSize: '13px',
              }}
            >
              {item.title || 0}
            </span>

            <StatsItemCount
              style={{
                marginBottom: '2px',
                fontSize: '10px',
              }}
            >
              {item.dec}
            </StatsItemCount>
          </StatsItems>
        ))}
    </StatsCard>
  )
}
const CourierLogo = styled.img`
  border-radius: 50%;
  width: 40px;
  height: 40px;
`

const StatsCard = styled(PixelAlert)<{ flexEnd?: boolean }>`
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 10px;
  width: 24%;
  margin: 0px;
  min-height: 90px;
`

const StatsItemTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #000;
  margin: 0px;
`
const StatsItemCount = styled.div<{ justify?: boolean }>`
  font-size: 10px;
  font-weight: 300;
  color: #000;
  margin: 0;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.justify ? 'flex-end' : 'space-between')};
  align-items: center;
  align-content: center;
`
const StatsItems = styled.div`
  display: flex;
  font-size: 18px;
  gap: 5px;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  align-items: flex-end;
  &.isCourier {
    flex-direction: column-reverse;
    align-content: flex-start;
    gap: 0px;
    align-items: flex-start;
    > div {
      margin-bottom: -5px;
    }
    > span {
      margin-bottom: 5px;
    }
  }
`

const AlertContainer = styled.div`
  border: 1px solid ${colors.grayBorderLight};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: ${colors.white};
`

const AlertTitle = styled.h3`
  color: ${colors.black};
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
`

const AlertDescription = styled.p`
  color: ${colors.black};
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
`

export default AlertCard
